<template>
  <div id="addEdit">
    <el-dialog :title="formData.graphic_id ? '编辑图文配置' : '添加图文配置'" :visible.sync="visible" width="700px">
      <el-form :model="formData" size="small" label-width="80px" ref="formRef" :rules="rules">
        <el-form-item label="key" prop="key">
          <el-input v-model="formData.key" :disabled="!!formData.graphic_id" placeholder="请输入唯一标识key"></el-input>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="formData.title" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <Uediter v-if="ueShow" :config="config" :text="formData.content" v-model="formData.content" @contentChange="contentChangeFunc"></Uediter>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="submitForm" :loading="loading">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Uediter from '@/components/UE.vue';
import SettingApi from '@/api/setting.js';
export default {
  components: { Uediter },
  data() {
    return {
      ueShow: false,
      visible: false,
      config: {
        initialFrameWidth: 580,
        initialFrameHeight: 500,
      },
      formData: {
        graphic_id: null,
        key: '',
        title: '',
        content: '',
      },
      rules: {
        key: [{ required: true, message: '请输入key', trigger: 'blur' }],
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        content: [{ required: true, message: '请输入内容', trigger: 'blur' }],
      },
      loading: false,
    };
  },
  methods: {
    show(e) {
      this.ueShow = false;
      this.visible = true;
      if (e && e !== '') {
        this.formData.graphic_id = (e.graphic_id != null ? e.graphic_id : (e.id != null ? e.id : null));
        this.formData.key = e.key != null ? e.key : '';
        this.formData.title = e.title != null ? e.title : '';
        this.formData.content = e.content != null ? e.content : '';
      } else {
        this.formData.graphic_id = null;
        this.formData.key = '';
        this.formData.title = '';
        this.formData.content = '';
      }
      this.$nextTick(() => {
        this.ueShow = true;
      });
    },

    submitForm() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          this.loading = true;
          const isEdit = this.formData.graphic_id != null && this.formData.graphic_id !== '';
          const API = isEdit ? SettingApi.graphicEdit : SettingApi.graphicAdd;
          API(this.formData).then(res => {
            this.$message({ message: '保存成功', type: 'success' });
            this.visible = false;
            this.$emit('refresh');
          }).finally(() => {
            this.loading = false;
          });
        }
      });
    },

    contentChangeFunc(e) {
      this.formData.content = e;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-image {
  width: 50px;
  height: 50px;
  margin: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/graphic/addEdit.vue